import { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import CreateTicketModal from './CreateTicketModal';

const FloatingHelpButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="fixed bottom-8 right-8 z-40 bg-indigo-600 text-white p-4 rounded-full shadow-lg hover:bg-indigo-700 transition-all hover:scale-110 flex items-center space-x-2 group"
        aria-label="Need Help?"
      >
        <HelpCircle className="w-6 h-6" />
        <span className="hidden md:block font-medium pr-2">Need Help?</span>
      </button>

      <CreateTicketModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        initialSubject=""
        initialDescription=""
      />
    </>
  );
};

export default FloatingHelpButton;

